import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export type AppLanguage = "es" | "en";
export const supportedLanguages: AppLanguage[] = ["es", "en"];

const savedLanguage = localStorage.getItem("GOP ALA-LANGUAGE");
const initialLanguage: AppLanguage = supportedLanguages.includes(
  savedLanguage as AppLanguage,
)
  ? (savedLanguage as AppLanguage)
  : "es";

void i18n.use(initReactI18next).init({
  lng: initialLanguage,
  fallbackLng: "es",
  supportedLngs: supportedLanguages,
  interpolation: { escapeValue: false },
  resources: {
    es: { translation: {} },
    en: { translation: {} },
  },
});

document.documentElement.lang =
  initialLanguage === "en" ? "en" : "es-EC";

export async function changeAppLanguage(language: AppLanguage) {
  localStorage.setItem("GOP ALA-LANGUAGE", language);
  document.documentElement.lang = language === "en" ? "en" : "es-EC";
  await i18n.changeLanguage(language);
}

export default i18n;
